import { createStyles } from "@mantine/emotion";

export default createStyles ( ( theme, props ) => {
	return {
		dropdown: {
			padding      : "0",
			minWidth     : "400px",
			background   : "none",
			border       : "none",
			overflow     : "hidden",
			borderRadius : "2rem"
		},
		drawerContent: {
			height       : "fit-content",
			borderRadius : "1rem 1rem 0 0"
		},
		useHereLink: {
			cursor         : "pointer",
			textDecoration : "underline",
			color          : theme.other.paletteNew.primaryLightBlue
		},
		padding: {
			background : theme.other.paletteNew.darkModeInclinedBlack1,
			padding    : "1.5rem"
		},
		header: {
			display        : "flex",
			justifyContent : "space-between",
			alignItems     : "center"
		},
		closeIconWrapper: {
			margin: "0.5rem"
		},
		inputRoot: {
			background : theme.other.paletteNew.darkModeInclinedBlack2,
			padding    : "2rem"
		},
		input: {
			background    : theme.other.paletteNew.darkModeDarkGrey20,
			borderRadius  : "0.8rem",
			border        : "1px solid transparent",
			textTransform : "uppercase",
			padding       : "2rem",
			transition    : "border 0.1s ease-in-out",
			":focus"      : {
				border: `1px solid ${ theme.other.paletteNew.primaryDarkBlue }`
			},
			"::placeholder": {
				textTransform: "capitalize"
			},
			"&[data-invalid]": {
				border: `1px solid ${ theme.other.paletteNew.tertiaryErrorRed }`
			}
		},
		inputWrapper: {
			marginBottom: "0"
		},
		rightSection: {
			marginRight: "1rem"
		},
		crossIcon: {
			width: "1.6rem"
		},
		error: {
			padding      : "1rem",
			borderRadius : "1rem",
			background   : theme.other.paletteNew.darkModeInclinedBlack1
		},
		footer: {
			display        : "flex",
			justifyContent : "flex-end",
			alignItems     : "center"
		},
		cancelBtn: {
			border     : "none",
			background : "none",
			color      : theme.other.paletteNew.primaryLightBlue,
			":hover"   : {
				background: "none"
			}
		},
		submitBtn: {
			padding: "0.8rem 2.4rem"
		}
	};
} );